export default function GetProductTypeEnum(){
  return productType;
}

const productType = {
  FullUW : 1,
  SPWL : 2,
  Haven : 3,
  HavenSI : 4,
  AmericoLoanProtector: 5
};
Object.freeze(productType);


// WEBPACK FOOTER //
// ./src/types/productType.js